import Grid from '@mui/material/Grid';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import { Item } from '../../shared/SelectedItems/Item.tsx';
import type { SelectedItemComponent } from '../../shared/SelectedItems/Items.tsx';

export const AudienceItemWithStatus: SelectedItemComponent = props => {
  const { children, option, testId } = props;

  return (
    <Grid
      wrap="nowrap"
      container
      sx={{
        gap: 1,
        flexGrow: 1,
        justifyContent: 'space-between',
      }}
    >
      <Grid
        sx={{
          paddingRight: 2,
        }}
      >
        <Item {...props}>{children}</Item>
      </Grid>
      <Grid size={2}>
        <Grid
          container
          sx={{
            paddingTop: 0.25,
            justifyContent: 'flex-end',
          }}
        >
          <StatusIndicator
            status={option?.status}
            data-test={testId?.replace('-item', '-status')}
            wrapperStyles={{
              display: 'inline-flex',
              alignItems: 'center',
              '& p': {
                display: 'inline',
                margin: 0,
              },
            }}
            textStyles={{ wordBreak: 'normal', whiteSpace: 'nowrap' }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
